module.exports = __webpack_public_path__ + "static/privacy-b30d8d5bfe3bb80ca9016cd9d4a170c7.png";